import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect, useParams, useLocation } from 'react-router';
import { GetEtablissementsByPartnerId, GetPartner, GetUsersByPartnerId } from '../../../actions/backoffice/partners';
import * as R from 'ramda';
import { DetailNav } from './_common/nav';

import { PartnersUsers } from './users';
import { PartnersEstablishment } from './establishment';
import { useDispatch } from 'react-redux';
import * as Loadings from '../../../constants/loadings/backoffice/partners';
import { LoadingState } from '../../../_common/loadingState';

export const PartnersDetail = ({ user, isLoading, partnerState }) => {
	const dispatch = useDispatch();
	const { partnerId } = useParams();


	useEffect(() => {
		dispatch(GetPartner(partnerId));
	}, []);



	if (partnerState.isLoading.includes(Loadings.FETCHING_PARTNER)) {
		return <LoadingState />;
	}

	if (R.isNil(partnerState.partner)) {
		return '';
	}



	return (
		<React.Fragment>
			<DetailNav partner={partnerState.partner} isLoading={isLoading} />
			<Switch>
				<Route exact path="/backoffice/partners/:partnerId/etablissements">
					<PartnersEstablishment user={user} partner={partnerState.partner} isLoading={isLoading} partnerState={partnerState} />
				</Route>
				<Route path="/backoffice/partners/:partnerId/users">
					<PartnersUsers user={user} partner={partnerState.partner} isLoading={isLoading} partnerState={partnerState} />
				</Route>
				<Route render={() => {
					return <Redirect exact to={`/backoffice/partners/${partnerId}/etablissements`} />;
				}} />
			</Switch>
		</React.Fragment>
	);
};